/* 外卖-模块API */

import { GET, POST, download, uploading, POSTFormData, EXPORT } from '@/request/http'

// 分页查询店铺
export const getShopTable = p => POST('/takeout/store/page', p, 2)

// 新增店铺
export const addShop = p => POSTFormData('/takeout/store/save', p, 2)

// 编辑店铺
export const editShop = p => POSTFormData('/takeout/store/update', p, 2)

// 编辑店铺环境图片
export const editShopEnviImage = p => POSTFormData('/takeout/store/enviimage/update', p, 2)

// 编辑店铺资质图片
export const editShopQualificationimage = p => POSTFormData('/takeout/store/qualificationimage/update', p, 2)

// 删除店铺
export const delShop = p => POST('/takeout/store/remove', p, 2)

// 根据店铺查询商品分类
export const getGoodsClassify = p => POST('/takeout/goodsclassify/list/bystoreid', p, 2)

// 新增商品分类
export const addGoodsClassify = p => POST('/takeout/goodsclassify/save', p, 2)

// 编辑商品分类
export const editGoodsClassify = p => POST('/takeout/goodsclassify/update', p, 2)

// 删除商品分类
export const delGoodsClassify = p => POST('/takeout/goodsclassify/remove', p, 2)

// 根据店铺查询商品列表
export const getGoodsList = p => POST('/takeout/goods/list/bystoreid', p, 2)

// 新增商品
export const addGoods = p => POSTFormData('/takeout/goods/save', p, 2)

// 编辑商品
export const editGoods = p => POSTFormData('/takeout/goods/update', p, 2)

// 删除商品
export const delGoods = p => POST('/takeout/goods/remove', p, 2)

// 获取当前用户店铺列表
export const getMyShopList = p => POST('/takeout/store/page', p, 2)

// 根据店铺id查询店铺信息
export const getShopInfoById = p => POST('/takeout/store/get', p, 2)

// 查询待接单订单
export const getTakeoutOrder = p => POST('/takeout/order/page', p, 1)

// 查询当前用户管理的店铺
export const getStoreList = p => POST('/takeout/store/page', p, 2)

// 更新店铺的推广排名
export const updateStoreRanking = p => POST('/takeout/store/ranking/update', p, 2)

// 查询当前用户能管理的位置树
export const getLocationByCurUser = p => POST('/takeout/operatepermission/locationtree/list/bycurrentuser', p, 2)

// 根据用户查询位置树
export const getLocationTreeByUserId = p => POST('/takeout/operatepermission/locationtree/list/byuserid', p, 2)

// 查询用户绑定的位置
export const getLocationByUserId = p => POST('/takeout/operatepermission/singlelevellocationid/list/byuserid', p, 2)

// 更新用户绑定的位置
export const updateTakeoutDuty = p => POST('/takeout/operatepermission/update', p, 2)

// 查询报表
export const getTakeoutReport = p => POST('/takeout/order/daliyreport/get/bycurrentuser', p, 2)
// export const getTakeoutReport = p => POST('/takeout/order/daliyreport/orgreport/get/bycurrentuserorg', p, 2)
// export const getTakeoutReport = p => POST('/takeout/order/daliyreport/storereport/get/bycurrentuserstore', p, 2)
// / takeout / order / daliyreport / orgreport / get / bycurrentuserorg

// 导出订单Excel

export const takeoutOrderExport = p => EXPORT('/takeout/order/export', p, 2)
// 导出营收统计Excel

export const takeoutDaliyReportExport = p => EXPORT('/takeout/order/daliyreport/export/bycurrentuser', p, 2)

// 批量送达
export const batchdeliveriedandremind = p => POST('/takeout/order/batchdeliveriedandremind', p, 2)

// 根据订单号送达
export const takeoutOrderDelivered = p => POST('/takeout/order/delivered', p, 2)

// 根据订单号送达
export const takeoutGetOrderInfo = p => POST('/takeout/order/get', p, 2)

// 查询订单及收入统计
export const getTakeoutOrderPagedetail = p => POST('/takeout/order/pagedetail', p)
// 查询当日配送批次分组列表
export const takeoutGetDeliveryBatchGroupList = p => POST('/takeout/delivery/batch/list', p)
// 查询批次列表
export const takeoutGetDeliveryBatchList = p => POST('/takeout/order/delivery/batchno/list', p)
// 查询当日批量配送情况汇总
export const takeoutGetDeliverySummary = p => POST('/takeout/batchdeliveried/summary/get', p)
// 开始配送
export const takeoutDeliverybegin = p => POST('/takeout/order/delivery/begin', p)
// 批量送达
export const takeoutBatchDeliveried = p => POST('/takeout/order/delivery/batchdeliveried', p, 1, 60000)
// 查询批量送达详情
export const takeoutGetBatchDeliveriedInfo = p => POST('/takeout/order/delivery/batchdetail', p)
// 查询批量送达详情
export const takeoutGetDelivaryBatchOrderList = p => POST('/takeout/delivarybatch/order/list', p)



// WEBPACK FOOTER //
// ./src/api/modules/takeout.js